import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  Card,
  CardBody,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Modal,
} from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import CrossIcon from "../../assets/images/close_icon.svg";
import TickIcon from "../../assets/images/tick_icon.svg";

import get from "lodash/get";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  approveRejectPartner,
  partnerGalleryModeration,
  PartnerRanking,
  putPartnerForm,
  fetchPartnersDetails,
  updatePartnerDetails,
  approveRejectUpdatedPartnerDetails,
} from "../../redux/partners/actions";
import InputText from "../InputText";
import PartnerPersonalForm from "../PartnerPersonalForm";
import history from "../../history";
import {
  uploadUrl,
  clearingPreviousReducer,
  uploadGalleryUrl,
  uploadVideoUrl,
} from "../../redux/uploadImage/action";
import config from "../../utils/config";
import {
  fetchingCountriesJson,
  fetchingRegionJson,
} from "../../redux/Global/actions";
import {
  fetchMotorCylce,
  fetchUserCountryMobileCode,
} from "../../redux/user/actions";
import Loader from "../Loader";
import Slider from "react-slick";
import UpdateModal from "../UpdateModal";

const _ = { get };

var settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function PartnerPersonalInformation(props) {
  const location = useHistory();
  const dispatch = useDispatch();
  const { elements } = useSelector((state) => state.Elements);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);
  const [toggleAddModal, setToggleAddModal] = useState(false);
  const [modal, setModal] = useState(false);
  const { countries, regionJson, tourCountriesJson } = useSelector(
    (state) => state.Global
  );
  const { partnerDetailsData, partnerRankingNumber } = useSelector(
    (state) => state.Partner
  );
  const { usertype } = useSelector((state) => state.Auth);
  const { userProfile } = useSelector((state) => state.Auth);
  const { countryMobileCode, motorCycle } = useSelector((state) => state.User);
  const { fetchingUpdatedDetails, updatedDetails } = useSelector(
    (state) => state.Partner
  );
  const [rejectImage, setRejectImage] = useState(false);
  const [rejectionType, setRejectionType] = useState("");
  const [rejectionId, setRejectionId] = useState("");
  const [imageDetails, setImageDetails] = useState(null);
  const [imageGalleryDetails, setImageGalleryDetails] = useState(null);
  const [previewImage, setPreviewImage] = useState(false);
  const [previewGalleryImage, setPreviewGalleryImage] = useState(false);
  const [previewType, setPreviewType] = useState("");
  const [previewImages, setPreviewImages] = useState([]);

  useEffect(() => {
    if (usertype === "EU Tours Admin" || usertype === "Admin")
      dispatch(
        fetchPartnersDetails(
          location &&
            location &&
            location.location.search &&
            location.location.search.split("=")[1]
        )
      );
    if (
      usertype === "EU Tours Partner" &&
      userProfile &&
      userProfile.additionalInfo
    ) {
      dispatch(fetchPartnersDetails(userProfile.additionalInfo.partnerId));
    }
    dispatch(fetchingRegionJson());
    dispatch(fetchingCountriesJson());
    dispatch(fetchUserCountryMobileCode());
    dispatch(fetchMotorCylce("uk"));
    dispatch(PartnerRanking());
  }, [userProfile, usertype]);

  const handleModalPreview = (data) => {
    setModal(!modal);
    if (data) {
      if (usertype === "EU Tours Admin" || usertype === "Admin") {
        dispatch(
          fetchPartnersDetails(
            location &&
              location &&
              location.location.search &&
              location.location.search.split("=")[1]
          )
        );
      } else {
        dispatch(fetchPartnersDetails(userProfile.additionalInfo.partnerId));
      }
    }
  };

  const handleRejectOnSubmit = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    if (usertype === "EU Tours Admin" || usertype === "Admin") {
      dispatch(
        fetchPartnersDetails(
          location &&
            location &&
            location.location.search &&
            location.location.search.split("=")[1]
        )
      );
    } else {
      dispatch(fetchPartnersDetails(userProfile.additionalInfo.partnerId));
    }
  };

  useEffect(() => {
    if (
      updatedDetails &&
      updatedDetails.changes &&
      updatedDetails.changes.length === 0 &&
      updatedDetails &&
      updatedDetails.gallery &&
      Object.keys(updatedDetails.gallery).length === 0
      && modal === true
    ) {
      setModal(!modal);
      if (usertype === "EU Tours Admin" || usertype === "Admin") {
        dispatch(
          fetchPartnersDetails(
            location &&
              location &&
              location.location.search &&
              location.location.search.split("=")[1]
          )
        );
      } else {
        dispatch(fetchPartnersDetails(userProfile.additionalInfo.partnerId));
      }
    }
  }, [updatedDetails]);

  const handleApprove = () => {
    let obj = {
      partnerId: partnerDetailsData._id,
      status: "APPROVED",
      email: partnerDetailsData.email,
    };
    dispatch(approveRejectPartner(obj));
  };

  const handleReject = () => {
    let obj = {
      partnerId: partnerDetailsData._id,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      email: partnerDetailsData.email,
    };
    let data = {
      partnerId: partnerDetailsData._id,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      key: "ALL",
    };
    setRejectionReason("");
    if (rejectionType === "Update") {
      if (rejectionReason !== "") {
        dispatch(approveRejectUpdatedPartnerDetails(data, handleRejectOnSubmit));
      }
    } else {
      dispatch(approveRejectPartner(obj));
    }
  };

  const handleGoBack = () => {
    if (location.location.state.route === "List") {
      history.push("/partner/list");
    } else {
      history.push("/");
    }
  };

  const handlePutPartner = (data) => {
    dispatch(putPartnerForm(data, handlePutCallBack));
  };

  const handleUpdatePartner = (data) => {
    dispatch(updatePartnerDetails(data, handlePutCallBack));
  };

  const handlePutCallBack = () => {
    setToggleAddModal(!toggleAddModal);
    dispatch(fetchPartnersDetails(userProfile.additionalInfo.partnerId));
  };

  const handleApproveGalleryModeration = (item, type) => {
    let obj = {
      status: "APPROVED",
      category: "PARTNER",
      assetId: item,
      categoryId: partnerDetailsData._id,
    };
    let obj2 = {
      status: "APPROVED",
      category: "PARTNER",
      categoryId: partnerDetailsData._id,
      groupId: item,
    };
    if (type === "All") {
      dispatch(partnerGalleryModeration(obj2, handleApproveRejectCallBack));
    } else {
      dispatch(partnerGalleryModeration(obj, handleApproveRejectCallBack));
    }
  };

  const handleRejectGalleryModeration = () => {
    let obj = {
      status: "REJECTED",
      category: "PARTNER",
      assetId: rejectionId,
      categoryId: partnerDetailsData._id,
    };
    let obj2 = {
      status: "REJECTED",
      category: "PARTNER",
      categoryId: partnerDetailsData._id,
      groupId: rejectionId,
    };
    setRejectionReason("");

    if (rejectionType === "All") {
      dispatch(partnerGalleryModeration(obj2, handleRejectCallBack));
    } else {
      dispatch(partnerGalleryModeration(obj, handleRejectCallBack));
    }
  };

  const handlePreviewImages = (e, image, type) => {
    setPreviewImage(!previewImage);
    setImageDetails(image);
    setPreviewType(type);
  };

  const handlePreviewGalleryImages = (e, image, type) => {
    setPreviewGalleryImage(!previewGalleryImage);
    setImageGalleryDetails(image);
    setPreviewType(type);
  };

  const handleApproveRejectCallBack = () => {
    dispatch(fetchPartnersDetails(location.location.search.split("=")[1]));
  };

  const handleRejectCallBack = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    dispatch(fetchPartnersDetails(location.location.search.split("=")[1]));
  };

  const approveOnClick = () => {
    let data = {
      partnerId: partnerDetailsData._id,
      status: "APPROVED",
      key: "ALL",
    };
    dispatch(approveRejectUpdatedPartnerDetails(data, handleApproveRejectCallBack));
  };

  return (
    <React.Fragment>
      <div className="hideSearch mt-4">
        {!partnerDetailsData && <Loader />}
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title={_.get(
                  elements,
                  "euToursElement.partnerPersonalInfoElement.headingElement",
                  "Partner Personal Information"
                )}
                iconClass={"hideexcel"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
              />
            </Col>
            {/* {usertype &&
              !(usertype === "EU Tours Admin" || usertype === "Admin") && (
                <Col sm={12}>
                  <p className="text-s mb-2 px-3">
                    <span>Note:</span> This is dummy text
                  </p>
                </Col>
              )} */}
          </Row>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col
                  xl={12}
                  lg={12}
                  md={6}
                  sm={6}
                  className="mb-4 mt-3 d-flex align-items-start justify-content-between updateBox"
                >
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.businessNameElement",
                      "Business Name"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.name
                        ? partnerDetailsData.name
                        : "N/A"
                    }
                  />
                  {partnerDetailsData &&
                    partnerDetailsData.moderationStatus === "MODIFIED" && (
                      <CustomButton
                        customType={"button"}
                        name="Update"
                        customClass={
                          "btn-outline-dark bg-none btnthemeColor partner_p_button"
                        }
                        customClick={() => {
                          handleModalPreview();
                          setRejectionType("Update");
                        }}
                      />
                    )}
                </Col>
                <Col xl={12} lg={12} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.shortBioElement",
                      "Short Bio (Profile) of your Business"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.bio
                        ? partnerDetailsData.bio
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.emailElement",
                      "Email"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.email
                        ? partnerDetailsData.email
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.contactNumberElement",
                      "Contact Number"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.mobile
                        ? `${partnerDetailsData.mobile.callingCode}${partnerDetailsData.mobile.number}`
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.alternativeNumberElement",
                      "Alternative Contact Number"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.secondaryNumber
                        ? `${partnerDetailsData.secondaryNumber.callingCode}${partnerDetailsData.secondaryNumber.number}`
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.websiteElement",
                      "Website"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.social
                        ? partnerDetailsData.social.website
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.instagramElement",
                      "Instagram"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.social
                        ? partnerDetailsData.social.instagram
                        : "N/A"
                    }
                  />
                </Col>
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                      <DesignCard
                        name={_.get(
                          elements,
                          "euToursElement.partnerPersonalInfoElement.regionRating",
                          "Partner Rating"
                        )}
                        titleName={
                          partnerDetailsData && partnerDetailsData.rating
                            ? partnerDetailsData.rating.region
                            : "N/A"
                        }
                      />
                    </Col>
                  )}
              </Row>
              <Row>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageLandingPageElement",
                      "Landing Page Filter Thumbnail (160 x 190 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.thumbnailImage &&
                  partnerDetailsData.moderateImage.thumbnailImage.images &&
                  partnerDetailsData.moderateImage.thumbnailImage.images
                    .srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage.thumbnailImage &&
                        partnerDetailsData.moderateImage.thumbnailImage
                          .images &&
                        partnerDetailsData.moderateImage.thumbnailImage.images
                          .srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage.thumbnailImage &&
                            partnerDetailsData.moderateImage.thumbnailImage
                              .images,
                          "image",
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage.thumbnailImage
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.thumbnailImage &&
                    partnerDetailsData.moderateImage.thumbnailImage.images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage.thumbnailImage &&
                          partnerDetailsData.moderateImage.thumbnailImage
                            .images &&
                          (partnerDetailsData.moderateImage.thumbnailImage
                            .images.moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage.thumbnailImage
                              .images.moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailImage.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailImage.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage.thumbnailImage &&
                          partnerDetailsData.moderateImage.thumbnailImage
                            .images &&
                          (partnerDetailsData.moderateImage.thumbnailImage
                            .images.moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage.thumbnailImage
                              .images.moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailImage.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailImage.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageListingPageElement",
                      "Partner Listing Page Thumbnail - Desktop (450 x 380 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.thumbnailListingDesktop &&
                  partnerDetailsData.moderateImage.thumbnailListingDesktop
                    .images &&
                  partnerDetailsData.moderateImage.thumbnailListingDesktop
                    .images.srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage
                          .thumbnailListingDesktop &&
                        partnerDetailsData.moderateImage.thumbnailListingDesktop
                          .images &&
                        partnerDetailsData.moderateImage.thumbnailListingDesktop
                          .images.srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage
                              .thumbnailListingDesktop &&
                            partnerDetailsData.moderateImage
                              .thumbnailListingDesktop.images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.thumbnailListingDesktop &&
                    partnerDetailsData.moderateImage.thumbnailListingDesktop
                      .images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingDesktop &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingDesktop.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailListingDesktop.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailListingDesktop.images
                              .moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingDesktop &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingDesktop.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingDesktop.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingDesktop &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingDesktop.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailListingDesktop.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailListingDesktop.images
                              .moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingDesktop &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingDesktop.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingDesktop.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageListingPageMobileElement",
                      "Partner Listing Page Thumbnail - Mobile (400 x 200 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.thumbnailListingMobile &&
                  partnerDetailsData.moderateImage.thumbnailListingMobile
                    .images &&
                  partnerDetailsData.moderateImage.thumbnailListingMobile.images
                    .srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage
                          .thumbnailListingMobile &&
                        partnerDetailsData.moderateImage.thumbnailListingMobile
                          .images &&
                        partnerDetailsData.moderateImage.thumbnailListingMobile
                          .images.srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage
                              .thumbnailListingMobile &&
                            partnerDetailsData.moderateImage
                              .thumbnailListingMobile.images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.thumbnailListingMobile &&
                    partnerDetailsData.moderateImage.thumbnailListingMobile
                      .images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingMobile &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingMobile.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailListingMobile.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailListingMobile.images
                              .moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingMobile &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingMobile.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingMobile.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingMobile &&
                          partnerDetailsData.moderateImage
                            .thumbnailListingMobile.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailListingMobile.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailListingMobile.images
                              .moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingMobile &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingMobile.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailListingMobile.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageDetailPageElement",
                      "Partner Detail Page - Top Banner - Desktop - (1920 x 620 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.thumbnailDetailDesktop &&
                  partnerDetailsData.moderateImage.thumbnailDetailDesktop
                    .images &&
                  partnerDetailsData.moderateImage.thumbnailDetailDesktop.images
                    .srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailDesktop &&
                        partnerDetailsData.moderateImage.thumbnailDetailDesktop
                          .images &&
                        partnerDetailsData.moderateImage.thumbnailDetailDesktop
                          .images.srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailDesktop &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailDesktop.images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.thumbnailDetailDesktop &&
                    partnerDetailsData.moderateImage.thumbnailDetailDesktop
                      .images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailDesktop &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailDesktop.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailDesktop.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailDesktop.images
                              .moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailDesktop &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailDesktop.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailDesktop.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailDesktop &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailDesktop.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailDesktop.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailDesktop.images
                              .moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailDesktop &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailDesktop.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailDesktop.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageDetailPageMobileElement",
                      "Partner Detail Page - Top Banner - Mobile - (450 x 800 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.thumbnailDetailMobile &&
                  partnerDetailsData.moderateImage.thumbnailDetailMobile
                    .images &&
                  partnerDetailsData.moderateImage.thumbnailDetailMobile.images
                    .srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailMobile &&
                        partnerDetailsData.moderateImage.thumbnailDetailMobile
                          .images &&
                        partnerDetailsData.moderateImage.thumbnailDetailMobile
                          .images.srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailMobile &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailMobile.images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.thumbnailDetailMobile &&
                    partnerDetailsData.moderateImage.thumbnailDetailMobile
                      .images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailMobile &&
                          partnerDetailsData.moderateImage.thumbnailDetailMobile
                            .images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailMobile.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailMobile.images.moderationStatus ===
                              "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailMobile &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailMobile.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailMobile.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailMobile &&
                          partnerDetailsData.moderateImage.thumbnailDetailMobile
                            .images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailMobile.images.moderationStatus ===
                            "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailMobile.images.moderationStatus ===
                              "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailMobile &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailMobile.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailMobile.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageBottomBannerDesktopElement",
                      "Partner Detail Page- Bottom Banner - Desktop - (1920 x 600 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage
                    .thumbnailDetailBannerDesktop &&
                  partnerDetailsData.moderateImage.thumbnailDetailBannerDesktop
                    .images &&
                  partnerDetailsData.moderateImage.thumbnailDetailBannerDesktop
                    .images.srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailBannerDesktop &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailBannerDesktop.images &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailBannerDesktop.images.srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerDesktop &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerDesktop.images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage
                      .thumbnailDetailBannerDesktop &&
                    partnerDetailsData.moderateImage
                      .thumbnailDetailBannerDesktop.images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerDesktop &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerDesktop.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailBannerDesktop.images
                            .moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerDesktop.images
                              .moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerDesktop &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerDesktop.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerDesktop.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerDesktop &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerDesktop.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailBannerDesktop.images
                            .moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerDesktop.images
                              .moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerDesktop &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerDesktop.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerDesktop.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageBottomBannerMobileElement",
                      "Partner Detail Page- Bottom Banner - Mobile - (450 x 480 px)(Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage
                    .thumbnailDetailBannerMobile &&
                  partnerDetailsData.moderateImage.thumbnailDetailBannerMobile
                    .images &&
                  partnerDetailsData.moderateImage.thumbnailDetailBannerMobile
                    .images.srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailBannerMobile &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailBannerMobile.images &&
                        partnerDetailsData.moderateImage
                          .thumbnailDetailBannerMobile.images.srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerMobile &&
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerMobile.images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage
                      .thumbnailDetailBannerMobile &&
                    partnerDetailsData.moderateImage.thumbnailDetailBannerMobile
                      .images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerMobile &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerMobile.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailBannerMobile.images
                            .moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerMobile.images
                              .moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerMobile &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerMobile.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerMobile.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerMobile &&
                          partnerDetailsData.moderateImage
                            .thumbnailDetailBannerMobile.images &&
                          (partnerDetailsData.moderateImage
                            .thumbnailDetailBannerMobile.images
                            .moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage
                              .thumbnailDetailBannerMobile.images
                              .moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerMobile &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerMobile.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailDetailBannerMobile.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
              </Row>
              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.countryWhereBusinessOperatesElement",
                      "Country where business operates"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.country
                        ? partnerDetailsData.country
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.countryOfferServices",
                      "Countries where you offer your services"
                    )}
                    titleName={
                      partnerDetailsData &&
                      partnerDetailsData.servicesOfferCounties
                        ? partnerDetailsData.servicesOfferCounties.toString()
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.businessEstablishedYear",
                      "Year your Business was established"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.establishYear
                        ? moment(partnerDetailsData.establishYear).format(
                            "YYYY"
                          )
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.reMotercycleFleet",
                      "Which RE motorcycles model do you have within your fleet? (Multiple)"
                    )}
                    titleName={
                      partnerDetailsData && partnerDetailsData.motorcycleModels
                        ? partnerDetailsData.motorcycleModels.toString()
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.nonGuidedTourElement",
                      "Do you offer motorcycle rental for non-guided tours?"
                    )}
                    titleName={
                      partnerDetailsData &&
                      partnerDetailsData.offerMotorcycle &&
                      partnerDetailsData.offerMotorcycle === true
                        ? "Yes"
                        : "No"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.guidedToursOfferedElement",
                      "Guided tours offered"
                    )}
                    titleName={
                      partnerDetailsData &&
                      partnerDetailsData.guidedTours &&
                      partnerDetailsData.guidedTours === true
                        ? "Yes"
                        : "No"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.selfRentalsElement",
                      "Self rentals options"
                    )}
                    titleName={
                      partnerDetailsData &&
                      partnerDetailsData.selfRental &&
                      partnerDetailsData.selfRental === true
                        ? "Yes"
                        : "No"
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4 mt-3">
                  <DesignCard
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.regionElement",
                      "Region"
                    )}
                    titleName={
                      partnerDetailsData &&
                      partnerDetailsData.region &&
                      partnerDetailsData.region[0]
                        ? partnerDetailsData.region[0]
                        : "N/A"
                    }
                  />
                </Col>
                <Col xl={12} className="mb-4 mt-3 ml-2">
                  <div className="personal_tour_image gallery-common-title">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.galleryImages",
                      "Gallery Common (Tap on the image to preview )"
                    )}
                  </div>
                </Col>
                <Col xl={12}>
                  <Row>
                    {partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.images &&
                    partnerDetailsData.moderateImage.images.images ? (
                      partnerDetailsData.moderateImage.images.images.map(
                        (item) => (
                          <Col
                            xl={2}
                            lg={2}
                            md={3}
                            sm={3}
                            className="mb-3 image-tour_main "
                          >
                            <div>
                              <img
                                className="image_tour2"
                                src={`${config.imageBaseUrl}/${item.srcPath}`}
                                alt="img"
                                onClick={(e) =>
                                  handlePreviewGalleryImages(
                                    e,
                                    partnerDetailsData.moderateImage.images
                                      .images,
                                    "image"
                                  )
                                }
                              />
                              {usertype &&
                                (usertype === "EU Tours Admin" ||
                                  usertype === "Admin") && (
                                  <div className="d-flex justify-content-center mt-n5">
                                    {(item.moderationStatus === "PENDING" ||
                                      item.moderationStatus === "APPROVED") && (
                                      <img
                                        className="image_gallery"
                                        alt="close"
                                        src={CrossIcon}
                                        onClick={() => {
                                          setRejectImage(true);
                                          setRejectionReasonToggle(
                                            !rejectionReasonToggle
                                          );
                                          setRejectionId(item._id);
                                        }}
                                      />
                                    )}
                                    {(item.moderationStatus === "PENDING" ||
                                      item.moderationStatus === "REJECTED") && (
                                      <img
                                        className="image_gallery"
                                        alt="tick"
                                        src={TickIcon}
                                        onClick={() =>
                                          handleApproveGalleryModeration(
                                            item._id
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                )}
                            </div>
                          </Col>
                        )
                      )
                    ) : (
                      <Col xl={12} className="ml-2">
                        {" "}
                        N/A
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
              {usertype &&
                (usertype === "EU Tours Admin" || usertype === "Admin") &&
                partnerDetailsData &&
                partnerDetailsData.moderateImage &&
                partnerDetailsData.moderateImage.images &&
                partnerDetailsData.moderateImage.images.images &&
                partnerDetailsData.moderateImage.images.images.length > 0 && (
                  <div className="d-flex justify-content-center justify-content-between position-relative mt-3">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.partnerPersonalInfoElement.rejectAllElement",
                        "Reject All Images"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => {
                        setRejectImage(true);
                        setRejectionReasonToggle(!rejectionReasonToggle);
                        setRejectionType("All");
                        setRejectionId(
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage.images &&
                            partnerDetailsData.moderateImage.images.groupId
                        );
                      }}
                    />
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.partnerPersonalInfoElement.acceptAllElement",
                        "Accept All Images"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() =>
                        handleApproveGalleryModeration(
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage.images &&
                            partnerDetailsData.moderateImage.images.groupId,
                          "All"
                        )
                      }
                    />
                  </div>
                )}
              <Row>
                <Col xl={2} lg={3} md={3} sm={3} className="mb-4 mt-3">
                  <div className="personal_tour_image">
                    {_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.thumbnailImageVideoPosterElement",
                      "Thumbnail - Partner Detail - Video Poster Image - (1920 x600 px) (Tap on the image to preview )"
                    )}
                  </div>
                  {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.thumbnailVideo &&
                  partnerDetailsData.moderateImage.thumbnailVideo.images &&
                  partnerDetailsData.moderateImage.thumbnailVideo.images
                    .srcPath ? (
                    <img
                      className="image_tour2"
                      src={`${config.imageBaseUrl}/${partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage.thumbnailVideo &&
                        partnerDetailsData.moderateImage.thumbnailVideo
                          .images &&
                        partnerDetailsData.moderateImage.thumbnailVideo.images
                          .srcPath}
                    `}
                      alt="img"
                      onClick={(e) =>
                        handlePreviewImages(
                          e,
                          partnerDetailsData &&
                            partnerDetailsData.moderateImage &&
                            partnerDetailsData.moderateImage.thumbnailVideo &&
                            partnerDetailsData.moderateImage.thumbnailVideo
                              .images,
                          "image"
                        )
                      }
                    />
                  ) : (
                    "N/A"
                  )}
                  {usertype &&
                    (usertype === "EU Tours Admin" || usertype === "Admin") &&
                    partnerDetailsData &&
                    partnerDetailsData.moderateImage &&
                    partnerDetailsData.moderateImage.thumbnailVideo &&
                    partnerDetailsData.moderateImage.thumbnailVideo.images && (
                      <div className="d-flex justify-content-center align-items-center mt-n5">
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage.thumbnailVideo &&
                          partnerDetailsData.moderateImage.thumbnailVideo
                            .images &&
                          (partnerDetailsData.moderateImage.thumbnailVideo
                            .images.moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage.thumbnailVideo
                              .images.moderationStatus === "APPROVED") && (
                            <img
                              className="image_gallery"
                              alt="close"
                              src={CrossIcon}
                              onClick={() => {
                                setRejectImage(true);
                                setRejectionReasonToggle(
                                  !rejectionReasonToggle
                                );
                                setRejectionId(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailVideo &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailVideo.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailVideo.images._id
                                );
                              }}
                            />
                          )}
                        {partnerDetailsData &&
                          partnerDetailsData.moderateImage &&
                          partnerDetailsData.moderateImage.thumbnailVideo &&
                          partnerDetailsData.moderateImage.thumbnailVideo
                            .images &&
                          (partnerDetailsData.moderateImage.thumbnailVideo
                            .images.moderationStatus === "PENDING" ||
                            partnerDetailsData.moderateImage.thumbnailVideo
                              .images.moderationStatus === "REJECTED") && (
                            <img
                              className="image_gallery"
                              alt="tick"
                              src={TickIcon}
                              onClick={() =>
                                handleApproveGalleryModeration(
                                  partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailVideo &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailVideo.images &&
                                    partnerDetailsData.moderateImage
                                      .thumbnailVideo.images._id
                                )
                              }
                            />
                          )}
                      </div>
                    )}
                </Col>
                {partnerDetailsData &&
                  partnerDetailsData.moderateImage &&
                  partnerDetailsData.moderateImage.video && (
                    <Col xl={12} className="mb-4 mt-3 ml-2">
                      <div className="personal_tour_image mb-3">
                        {_.get(
                          elements,
                          "euToursElement.partnerPersonalInfoElement.videoElement",
                          "Video (Tap on the video to preview )"
                        )}
                      </div>
                      <Row>
                        {partnerDetailsData &&
                        partnerDetailsData.moderateImage &&
                        partnerDetailsData.moderateImage.video &&
                        partnerDetailsData.moderateImage.video.images ? (
                          <Col xl={3} lg={3} md={6} sm={12}>
                            <video
                              // className="img-fluid"
                              width="100%"
                              height="230px"
                              controls
                              onClick={(e) =>
                                handlePreviewImages(
                                  e,
                                  partnerDetailsData &&
                                    partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage.video &&
                                    partnerDetailsData.moderateImage.video
                                      .images,
                                  "video"
                                )
                              }
                            >
                              <source
                                src={`${
                                  config.imageBaseUrl
                                }/${partnerDetailsData &&
                                  partnerDetailsData.moderateImage &&
                                  partnerDetailsData.moderateImage.video &&
                                  partnerDetailsData.moderateImage.video
                                    .images &&
                                  partnerDetailsData.moderateImage.video.images
                                    .srcPath}`}
                                type="video/mp4"
                              ></source>
                            </video>

                            {usertype &&
                              (usertype === "EU Tours Admin" ||
                                usertype === "Admin") && (
                                <div className="d-flex justify-content-center mt-n5 center_rjct_apr">
                                  {partnerDetailsData &&
                                    partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage.video &&
                                    partnerDetailsData.moderateImage.video
                                      .images &&
                                    (partnerDetailsData.moderateImage.video
                                      .images.moderationStatus === "PENDING" ||
                                      partnerDetailsData.moderateImage.video
                                        .images.moderationStatus ===
                                        "APPROVED") && (
                                      <img
                                        className="image_gallery"
                                        alt="close"
                                        src={CrossIcon}
                                        onClick={() => {
                                          setRejectImage(true);
                                          setRejectionReasonToggle(
                                            !rejectionReasonToggle
                                          );
                                          setRejectionId(
                                            partnerDetailsData &&
                                              partnerDetailsData.moderateImage &&
                                              partnerDetailsData.moderateImage
                                                .video &&
                                              partnerDetailsData.moderateImage
                                                .video.images &&
                                              partnerDetailsData.moderateImage
                                                .video.images._id
                                          );
                                        }}
                                      />
                                    )}
                                  {partnerDetailsData &&
                                    partnerDetailsData.moderateImage &&
                                    partnerDetailsData.moderateImage.video &&
                                    partnerDetailsData.moderateImage.video
                                      .images &&
                                    (partnerDetailsData.moderateImage.video
                                      .images.moderationStatus === "PENDING" ||
                                      partnerDetailsData.moderateImage.video
                                        .images.moderationStatus ===
                                        "REJECTED") && (
                                      <img
                                        className="image_gallery"
                                        alt="tick"
                                        src={TickIcon}
                                        onClick={() =>
                                          handleApproveGalleryModeration(
                                            partnerDetailsData &&
                                              partnerDetailsData.moderateImage &&
                                              partnerDetailsData.moderateImage
                                                .video &&
                                              partnerDetailsData.moderateImage
                                                .video.images &&
                                              partnerDetailsData.moderateImage
                                                .video.images._id
                                          )
                                        }
                                      />
                                    )}
                                </div>
                              )}
                          </Col>
                        ) : (
                          <Col xl={3} lg={3} md={6} sm={12}>
                            N/A
                          </Col>
                        )}
                      </Row>
                    </Col>
                  )}
              </Row>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative mt-5">
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.partnerPersonalInfoElement.backElement",
                        "Back"
                      )}
                      customClass={"btn-outline-dark bg-none btnthemeColor"}
                      customClick={() => handleGoBack()}
                    />
                  )}
                {usertype && usertype === "EU Tours Partner" && (
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "euToursElement.partnerPersonalInfoElement.editElement",
                      "Edit"
                    )}
                    customClass={"btn-outline-dark bg-none ml-3 btnthemeColor"}
                    customClick={() => setToggleAddModal(!toggleAddModal)}
                  />
                )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") &&
                  partnerDetailsData &&
                  (partnerDetailsData.moderationStatus === "PENDING" ||
                    partnerDetailsData.moderationStatus === "APPROVED") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.partnerPersonalInfoElement.rejectElement",
                        "Reject"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() =>
                        setRejectionReasonToggle(!rejectionReasonToggle)
                      }
                    />
                  )}
                {usertype &&
                  (usertype === "EU Tours Admin" || usertype === "Admin") &&
                  partnerDetailsData &&
                  (partnerDetailsData.moderationStatus === "PENDING" ||
                    partnerDetailsData.moderationStatus === "REJECTED") && (
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "euToursElement.partnerPersonalInfoElement.approveElement",
                        "Approve"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-3 btnthemeColor"
                      }
                      customClick={() => handleApprove()}
                    />
                  )}
              </div>
            </CardBody>
          </Card>
        </Form>
        <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
          <ModalHeader
            toggle={() => {
              setRejectionReasonToggle(!rejectionReasonToggle);
              setRejectionReason("");
            }}
          >
            {_.get(
              elements,
              "euToursElement.partnerPersonalInfoElement.rejectionModelLabel",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={rejectionReason}
              customOnChange={(e) => setRejectionReason(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            {rejectImage === false ? (
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.partnerPersonalInfoElement.rejectElement",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => handleReject(e)}
              />
            ) : (
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.partnerPersonalInfoElement.rejectElement",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => handleRejectGalleryModeration(e)}
              />
            )}
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={toggleAddModal}
          toggle={() => setToggleAddModal(!toggleAddModal)}
          backdrop={true}
          centered={true}
          size="xl"
          className="modal_main"
        >
          <ModalBody>
            <PartnerPersonalForm
              handleToggleModel={() => setToggleAddModal(!toggleAddModal)}
              countryList={tourCountriesJson}
              partnerDetailsData={partnerDetailsData}
              usertype={usertype}
              editInfo={true}
              handlePutPartner={handlePutPartner}
              handleUpdatePartner={handleUpdatePartner}
              uploadUrl={(data, callback, category) =>
                dispatch(uploadUrl(data, callback, category))
              }
              clearingPreviousReducer={clearingPreviousReducer}
              uploadGalleryUrl={(data, callback, category) =>
                dispatch(uploadGalleryUrl(data, callback, category))
              }
              uploadVideoUrl={(data, callback, category) =>
                dispatch(uploadVideoUrl(data, callback, category))
              }
              regionJson={regionJson}
              countryMobileCode={countryMobileCode}
              motorCycle={motorCycle}
              partnerRankingNumber={partnerRankingNumber}
              formType={"update"}
            />
          </ModalBody>
        </Modal>
        {console.log("data", imageGalleryDetails)}
        <Modal size="xl" centered isOpen={previewGalleryImage}>
          <ModalHeader toggle={handlePreviewGalleryImages}></ModalHeader>
          <ModalBody>
            <div className="slider">
              <Slider {...settings}>
                {imageGalleryDetails &&
                  imageGalleryDetails.map((item) => (
                    <div>
                      <img
                        src={`${config.imageBaseUrl}/${item.srcPath}`}
                        alt=""
                        className="w-100 preview_InnerImage"
                      />
                    </div>
                  ))}
              </Slider>
            </div>
          </ModalBody>
        </Modal>
        <Modal size="m" centered isOpen={previewImage}>
          <ModalHeader toggle={handlePreviewImages} className="dotted_Heading">
            {imageDetails &&
              imageDetails.srcPath.slice(
                imageDetails.srcPath.lastIndexOf("/") + 1
              )}
          </ModalHeader>
          <ModalBody>
            {imageDetails && previewType === "image" ? (
              <>
                <img
                  src={`${config.imageBaseUrl}/${imageDetails.srcPath}`}
                  className="w-100"
                />
              </>
            ) : previewType === "video" ? (
              <>
                <video width="100%" height="230px" controls>
                  <source
                    src={`${config.imageBaseUrl}/${imageDetails.srcPath}`}
                    type="video/mp4"
                  ></source>
                </video>
              </>
            ) : (
              ""
            )}
          </ModalBody>
        </Modal>
        <Modal
          isOpen={modal}
          toggle={() => handleModalPreview()}
          className="update_preview_modal"
          centered
          scrollable
          size="lg"
        >
          <ModalHeader className="d-block">
            <div className="d-flex justify-content-between flex-column flex-lg-row light-border-bottom header-bg main-title align-items-center py-2 px-2 rounded">
              <div className="CartTitle d-flex align-items-center  justify-content-lg-start justify-content-center">
                <h4 className="text-light text-capitalize m-0 ml-2">
                  <span>Partner Personal Information</span>
                </h4>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Row>
              <UpdateModal
                partnerId={partnerDetailsData && partnerDetailsData._id}
              />
            </Row>
          </ModalBody>

          <ModalFooter>
            <CustomButton
              customType={"button"}
              name="Close"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() => handleModalPreview("modalUpdate")}
            />
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") &&
              updatedDetails &&
              ((updatedDetails.changes && updatedDetails.changes.length > 1) ||
                updatedDetails.gallery) && (
                <CustomButton
                  customType={"button"}
                  name="Approve All"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => approveOnClick()}
                />
              )}
            {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") &&
              updatedDetails &&
              (updatedDetails.changes || updatedDetails.gallery) && (
                <CustomButton
                  customType={"button"}
                  name="Reject All"
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() =>
                    setRejectionReasonToggle(!rejectionReasonToggle)
                  }
                />
              )}
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}
